import { Link } from "react-router-dom";
import React from "react";

const LenderTitle = ({ title, id }) => {
  return <Link to={"/lender/item/" + id}>{title}</Link>;
};

export default LenderTitle;
